<div class="custom-field-panel">
  <div class="custom-field-panel-header">
    <div class="title">Add Field</div>
  </div>
  <div class="content">
    <form [formGroup]="customFieldForm">
      <div class="row">
        <mat-form-field [class.pointer-events-none]="onlyLabelEditable" class="field treo-mat-no-subscript">
          <mat-label>Field Type</mat-label>
          <mat-select [formControlName]="'type'">
            <mat-option [value]="'checkbox'">Checkbox</mat-option>
            <mat-option [value]="'money'">Currency</mat-option>
            <mat-option [value]="'date'">Date</mat-option>
            <mat-option [value]="'decimal'">Decimal (1.00)</mat-option>
            <mat-option [value]="'number'">Number (1,000)</mat-option>
            <mat-option [value]="'percent'">Percent</mat-option>
            <mat-option [value]="'record'">Related To</mat-option>
            <mat-option [value]="'select'">Single Select</mat-option>
            <mat-option [value]="'multi_select'">Multi Select</mat-option>
            <mat-option [value]="'text'">Text</mat-option>
            <mat-option [value]="'url'">Url</mat-option>
            <mat-option [value]="'year'">Year</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row" *ngIf="customFieldForm?.get('type')?.value === 'record'">
        <mat-form-field [class.pointer-events-none]="onlyLabelEditable" class="field treo-mat-no-subscript">
          <mat-label>Record Type</mat-label>
          <mat-select [formControlName]="'record_type'">
            <mat-option [value]="'Contact'">Contact</mat-option>
            <mat-option [value]="'Company'">Company</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="field treo-mat-no-subscript">
          <mat-label>Field Name</mat-label>
          <input matInput [formControlName]="'label'" [placeholder]="'Field Name'" />
        </mat-form-field>
      </div>
      <ng-container formArrayName="options" *ngIf="showValues">
        <div class="row" *ngFor="let _ of dropDownValue.controls; index as i">
          <mat-form-field [class.pointer-events-none]="onlyLabelEditable" class="field treo-mat-no-subscript">
            <mat-label>Value {{ i + 1 }} </mat-label>
            <button *ngIf="i === 0" class="add-field" mat-icon-button (click)="addDropdownValue()" matTooltip="Add">
              <mat-icon [svgIcon]="'add_circle'"></mat-icon>
            </button>
            <button
              *ngIf="i !== 0"
              class="add-field"
              mat-icon-button
              (click)="removeDropdownValue(i)"
              matTooltip="Remove"
            >
              <mat-icon [svgIcon]="'remove_circle'"></mat-icon>
            </button>
            <input matInput [formControlName]="i" [placeholder]="'value'" />
          </mat-form-field>
        </div>
      </ng-container>
      <div class="row m-1 mt-0" *ngIf="customFieldForm?.get('type')?.value !== 'record'">
        <mat-label>
          <div class="font-medium">
            <mat-checkbox
              [class.pointer-events-none]="onlyLabelEditable"
              [color]="'primary'"
              [formControlName]="'calcField'"
            >
              Auto Calc Field
            </mat-checkbox>
          </div>
        </mat-label>
      </div>
      <div class="row" *ngIf="customFieldForm?.get('type')?.value !== 'record'">
        <div
          class="flex items-start treo-mat-textarea treo-mat-no-subscript w-full"
          *ngIf="!customFieldForm.get('calc_code').disabled"
        >
          <mat-form-field [class.pointer-events-none]="onlyLabelEditable" class="field treo-mat-no-subscript">
            <textarea
              class="leading-normal my-2 text-sm h-20"
              [mentionConfig]="mentionConfig"
              matInput
              cdkTextareaAutosize
              [formControlName]="'calc_code'"
              [placeholder]="'@ for functions and \n# for fields \nE.g. SUM( far, noi )'"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <button
        class="add"
        mat-flat-button
        type="button"
        [color]="'primary'"
        DebounceClick
        (debounceClick)="createCustomField()"
        [disabled]="customFieldForm.disabled || customFieldForm.pristine || customFieldForm.invalid"
      >
        <span *ngIf="!customFieldForm.disabled">Add</span>
        <mat-progress-spinner *ngIf="customFieldForm.disabled" [diameter]="24" [mode]="'indeterminate'">
        </mat-progress-spinner>
      </button>
    </form>
  </div>
</div>
